import {createTheme} from "@mui/material/styles";
import RobotoRegularTtf from "../../../fonts/Roboto/Roboto-Regular.ttf";
import RobotoLightTtf from "../../../fonts/Roboto/Roboto-Light.ttf";
import RobotoBoldTtf from "../../../fonts/Roboto/Roboto-Bold.ttf";

const theme = createTheme({
    palette: {
        primary: {main: '#ff6c0e'},
        secondary: {
            main: '#63666a',
            contrastText: '#b1b3b3',
        },
        background: {
            default: '#fff',
            paper: '#fff',
        },
    },
    typography: {
        fontFamily: 'Roboto',
    },
    components: {
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    '&.Mui-focused': {
                        color: '#645757',
                    },
                },
            },
        },
        MuiPaginationItem: {
            styleOverrides: {
                rounded: {
                    borderRadius: '0',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    fontWeight: 'bold',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    boxShadow: 'none',
                    borderRadius: '0',
                    padding: '5px 15px',
                },
                contained: {
                    boxShadow: 'none',
                    border: `rgb(0, 0, 0, 0.25) 1px solid`,
                    padding: '5px 15px',
                    color: '#fff'
                },
                outlinedSecondary: {
                    boxShadow: 'none',
                    color: '#ff6c0e',
                    background: '#fff',
                    border: `rgb(0, 0, 0, 0.25) 1px solid`,
                    padding: '5px 15px',
                },
            },
        },
        MuiStepIcon: {
            styleOverrides: {
                root: {
                    '&.Mui-active': {
                        color: '#0f0f0f !important',
                    },
                    '&.Mui-completed': {
                        color: 'rgba(0, 0, 0, 0.38) !important',
                    },
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                    boxShadow: 'none',
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: `
                @font-face {
                    font-family: 'Roboto';
                    font-style: normal;
                    font-display: swap;
                    font-weight: 440;
                    src: local('Roboto-Regular.ttf'), local('Roboto'), url(${RobotoRegularTtf}) format('truetype');
                    unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
                },
                @font-face {
                    font-family: 'Roboto';
                    font-style: light;
                    font-display: swap;
                    font-weight: 340;
                    src: local('Roboto-Light.ttf'), local('Roboto'), url(${RobotoLightTtf}) format('truetype');
                    unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
                },
                @font-face {
                    font-family: 'Roboto';
                    font-style: bold;
                    font-display: swap;
                    font-weight: 630;
                    src: local('Roboto-Bold.ttf'), local('Roboto'), url(${RobotoBoldTtf}) format('truetype');
                    unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
                },                
            `,
        },
    },
})

export default theme